import { isEvmAddressHex } from 'utils/isEvmAddressHex';

export function normalizeParam(value: string) {
  return isEvmAddressHex(value) ? value.toLowerCase() : value;
}
